<template>
  <v-container
    fluid
    v-if="getExamActivityStatus.IncourseMarkSubmission == true"
  >
    <!-- ================= SEARCH ================= -->
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-layout row>
            <v-text-field
              solo
              flat
              hide-details
              label="REG No"
              prepend-inner-icon="search"
              v-model="searchParam.reg_no"
            />
            <v-card-actions>
              <v-btn color="info" dark @click="searchData">Search</v-btn>
            </v-card-actions>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- ================= STUDENT INFO ================= -->

    <v-layout
      row
      wrap
      style="margin-top:20px"
      v-if="student && searchParam.reg_no"
    >
      <v-flex xs12>
        <v-card color="white">
          <v-card-text>
            <div class="data-bar">
              <div class="item">
                <span class="label">REGISTRATION NO:</span>
                <span class="value">
                  {{ student.reg_no }}
                </span>
              </div>

              <div class="item">
                <span class="label">NAME:</span>
                <span class="value">
                  {{ student.name ? student.name : "N/A" }}
                </span>
              </div>

              <div class="item">
                <span class="label">FATHER'S NAME:</span>
                <span class="value">
                  {{ student.father_name ? student.father_name : "N/A" }}
                </span>
              </div>

              <div class="item">
                <span class="label">MOTHER'S NAME:</span>
                <span class="value">
                  {{ student.mother_name ? student.mother_name : "N/A" }}
                </span>
              </div>

              <div class="item">
                <span class="label">SESSION:</span>
                <span class="value">
                  {{ student.ac_session ? student.ac_session : "N/A" }}
                </span>
              </div>

              <div class="item">
                <span class="label">STUDENT TYPE:</span>
                <span class="value">
                  {{
                    apiData.form_fill_up.candi_date_type.candidate_type
                      ? apiData.form_fill_up.candi_date_type.candidate_type
                      : "N/A"
                  }}
                </span>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- ================= COMPULSORY ================= -->
    <v-layout v-if="compulsory_subject.length && searchParam.reg_no" mt-3>
      <v-flex xs12>
        <v-card style="padding:16px;">
          <v-toolbar flat dark height="40">
            <v-toolbar-title>Compulsory Subjects</v-toolbar-title>
          </v-toolbar>
          <v-data-table
            :headers="headers"
            :items="compulsory_subject"
            hide-actions
          >
            <template slot="items" slot-scope="props">
              <tr>
                <td>{{ props.item.core_paper.paper_name }}</td>
                <td class="text-xs-center">
                  {{ props.item.core_paper.paper_code }}
                </td>
                <!-- v-if="showIncourse(props.item)" -->
                <td class="text-xs-center">
                  <v-text-field
                    v-if="props.item.incourse_status == true"
                    v-model="props.item.incourse_paper_marks"
                    :error-messages="
                      errors[props.item.core_paper.paper_code + '_incourse'] ||
                        []
                    "
                    :rules="[
                      (v) => rules.required(v, submitted),
                      rules.min(props.item.core_paper.minimum_incourse_marks),
                      rules.max(props.item.core_paper.incourse_marks),
                    ]"
                    :label="
                      'Enter Value' +
                        '(' +
                        props.item.core_paper.minimum_incourse_marks +
                        ' - ' +
                        props.item.core_paper.incourse_marks +
                        ')'
                    "
                  />
                  <span v-else>N/A</span>
                </td>
                <td class="text-xs-center">
                  <!-- v-if="showAttendance(props.item)" -->
                  <v-text-field
                    v-if="props.item.att_incourse_status == true"
                    v-model="props.item.att_incourse_marks"
                    :error-messages="
                      errors[
                        props.item.core_paper.paper_code + '_attendance'
                      ] || []
                    "
                    :rules="[
                      (v) => rules.required(v, submitted),
                      rules.min(props.item.core_paper.min_att_incourse_marks),
                      rules.max(props.item.core_paper.att_incourse_marks),
                    ]"
                    :label="
                      'Enter Value ' +
                        '(' +
                        props.item.core_paper.min_att_incourse_marks +
                        ' - ' +
                        props.item.core_paper.att_incourse_marks +
                        ')'
                    "
                  />
                  <span v-else>N/A</span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- ================= ELECTIVE ================= -->
    <v-layout
      v-if="Object.keys(elective_subject).length && searchParam.reg_no"
      mt-3
    >
      <v-flex xs12>
        <v-card style="padding:16px;">
          <v-toolbar flat dark height="40">
            <v-toolbar-title>Elective Subjects</v-toolbar-title>
          </v-toolbar>

          <div
            v-for="(group, gName) in elective_subject"
            :key="gName"
            v-if="showGroupBySet(group)"
            class="paper-group"
          >
            <v-toolbar flat height="35">
              <v-toolbar-title>
                Group {{ gName }}
                <small v-if="group[0].core_paper.paper_group.show_name == 1">
                  (select any
                  {{ group[0].core_paper.paper_group.number_of_paper }} of
                  {{ group.length }})
                </small>
              </v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>

            <v-data-table
              :headers="checkboxHeaders"
              :items="group"
              hide-actions
            >
              <template slot="items" slot-scope="props">
                <tr v-if="showPaperByLimit(gName, props.item)">
                  <td>
                    <v-checkbox
                      :input-value="isElectiveSelected(gName, props.item)"
                      @change="toggleElective(gName, props.item)"
                      hide-details
                    />
                  </td>
                  <td>{{ props.item.core_paper.paper_name }}</td>
                  <td class="text-xs-center">
                    {{ props.item.core_paper.paper_code }}
                  </td>
                  <td class="text-xs-center">
                    <v-text-field
                      v-if="
                        isElectiveSelected(gName, props.item) &&
                          showIncourse(props.item) &&
                          props.item.incourse_status == true
                      "
                      v-model="props.item.incourse_paper_marks"
                      :error-messages="
                        errors[
                          props.item.core_paper.paper_code + '_incourse'
                        ] || []
                      "
                      :rules="[
                        (v) => rules.required(v, submitted),
                        rules.min(props.item.core_paper.minimum_incourse_marks),
                        rules.max(props.item.core_paper.incourse_marks),
                      ]"
                      :label="
                        'Enter Value ' +
                          '(' +
                          props.item.core_paper.minimum_incourse_marks +
                          ' - ' +
                          props.item.core_paper.incourse_marks +
                          ')'
                      "
                    />
                    <span v-else>N/A</span>
                  </td>
                  <td class="text-xs-center">
                    <v-text-field
                      v-if="
                        isElectiveSelected(gName, props.item) &&
                          showAttendance(props.item) &&
                          props.item.att_incourse_status == true
                      "
                      v-model="props.item.att_incourse_marks"
                      :error-messages="
                        errors[
                          props.item.core_paper.paper_code + '_attendance'
                        ] || []
                      "
                      :rules="[
                        (v) => rules.required(v, submitted),
                        rules.min(props.item.core_paper.min_att_incourse_marks),
                        rules.max(props.item.core_paper.att_incourse_marks),
                      ]"
                      :label="
                        'Enter Value ' +
                          '(' +
                          props.item.core_paper.min_att_incourse_marks +
                          ' - ' +
                          props.item.core_paper.att_incourse_marks +
                          ')'
                      "
                    />
                    <span v-else>N/A</span>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- ================= IMPROVEMENT ================= -->
    <v-layout v-if="improvement_subject.length" mt-3>
      <v-flex xs12>
        <v-card style="padding:16px;">
          <v-toolbar flat dark height="40">
            <v-toolbar-title>Improvement Subjects</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn flat>
              Any {{ allowedImprovement }} of {{ improvement_subject.length }}
            </v-btn>
          </v-toolbar>

          <v-data-table
            :headers="checkboxHeaders"
            :items="filteredImprovementSubjects"
            hide-actions
          >
            <template slot="items" slot-scope="props">
              <tr>
                <td>
                  <v-checkbox
                    :input-value="isImprovementSelected(props.item)"
                    @change="toggleImprovement(props.item)"
                    hide-details
                  />
                </td>
                <td>{{ props.item.core_paper.paper_name }}</td>
                <td class="text-xs-center">
                  {{ props.item.core_paper.paper_code }}
                </td>
                <td class="text-xs-center">
                  <v-text-field
                    v-if="props.item.incourse_status"
                    v-model="props.item.incourse_paper_marks"
                    :error-messages="
                      errors[props.item.core_paper.paper_code + '_incourse'] ||
                        []
                    "
                    :rules="[
                      (v) => rules.required(v, submitted),
                      rules.min(props.item.core_paper.minimum_incourse_marks),
                      rules.max(props.item.core_paper.incourse_marks),
                    ]"
                    :label="
                      'Enter Value ' +
                        '(' +
                        props.item.core_paper.minimum_incourse_marks +
                        ' - ' +
                        props.item.core_paper.incourse_marks +
                        ')'
                    "
                  />
                  <span v-else>N/A</span>
                </td>
                <td class="text-xs-center">
                  <v-text-field
                    v-if="props.item.att_incourse_status"
                    v-model="props.item.att_incourse_marks"
                    :error-messages="
                      errors[
                        props.item.core_paper.paper_code + '_attendance'
                      ] || []
                    "
                    :rules="[
                      (v) => rules.required(v, submitted),
                      rules.min(props.item.core_paper.min_att_incourse_marks),
                      rules.max(props.item.core_paper.att_incourse_marks),
                    ]"
                    :label="
                      'Enter Value ' +
                        '(' +
                        props.item.core_paper.min_att_incourse_marks +
                        ' - ' +
                        props.item.core_paper.att_incourse_marks +
                        ')'
                    "
                  />
                  <span v-else>N/A</span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 class="text-xs-center">
        <v-btn
          color="primary"
          class="mt-4"
          :disabled="!show_button"
          @click="submitInvMarks"
        >
          Submit
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
  <v-container fluid v-else>
    <v-card>
      <v-layout row align-center justify-center>
        <v-card-text
          class="text-xs-center"
          style="background-color: brown; color: white;"
        >
          <v-icon style="color: aliceblue; font-size:xx-large;">warning</v-icon>
          <h2>Incourse Mark Submission Is Not Started Yet !</h2>
        </v-card-text>
      </v-layout>
    </v-card>
  </v-container>
</template>

<script>
import commonGet from "@/mixin/common_getters_mixin";
import commonExamYear from "@/mixin/exam_year_watch_mixin";

export default {
  mixins: [commonGet, commonExamYear],

  data() {
    return {
      searchParam: { reg_no: null },
      current_privilege: null,
      selectedElective: {},
      selectedImprovement: [],
      paper_group_set: null,
      group_wise_selected: {},
      ele_group: null,
      total_papers: 0,
      total_selected_papers: 0,
      show_button: false,
      submitted: false,
      errors: {},
    };
  },

  computed: {
    getExamActivityStatus() {
      return this.$store.getters.getExamActivityStatus;
    },
    apiData() {
      return this.$store.getters.getIncourseData || {};
    },
    student() {
      return this.apiData.form_fill_up && this.apiData.form_fill_up.student
        ? this.apiData.form_fill_up.student
        : null;
    },
    ffCriteria() {
      return this.apiData.form_fill_up && this.apiData.form_fill_up.ff_criteria
        ? Number(this.apiData.form_fill_up.ff_criteria)
        : 0;
    },
    compulsory_subject() {
      return this.apiData.compulsory_subject
        ? this.apiData.compulsory_subject
        : [];
    },
    elective_subject() {
      return this.apiData.elective_subject ? this.apiData.elective_subject : {};
    },
    improvement_subject() {
      return this.apiData.improvement_subject
        ? this.apiData.improvement_subject
        : [];
    },

    allowedImprovement() {
      return this.apiData.form_fill_up &&
        this.apiData.form_fill_up.improvement_papers
        ? this.apiData.form_fill_up.improvement_papers
        : 0;
    },
    filteredImprovementSubjects() {
      if (this.selectedImprovement.length >= this.allowedImprovement) {
        return this.selectedImprovement;
      }
      return this.improvement_subject;
    },

    headers() {
      return [
        { text: "Paper Name", value: "name" },
        { text: "Code", value: "code" },
        { text: "Incourse + Assignment", value: "incourse" },
        { text: "Attendance", value: "attendance" },
      ];
    },

    checkboxHeaders() {
      return [
        { text: "", value: "select" },
        { text: "Paper Name", value: "name" },
        { text: "Code", value: "code" },
        { text: "Incourse + Assignment", value: "incourse" },
        { text: "Attendance", value: "attendance" },
      ];
    },

    rules() {
      return {
        required: (v, submitted) => {
          if (!submitted) return true;
          return (
            (v !== null && v !== "" && v !== undefined) || "Marks are required"
          );
        },
        min: (min) => (v) => Number(v) >= min || "Min " + min,
        max: (max) => (v) => Number(v) <= max || "Max " + max,
      };
    },
    ele_sub() {
      return Object.values(this.group_wise_selected).flat();
    },
  },

  watch: {
    group_wise_selected: {
      deep: true,
      handler() {
        this.checkSubmitButton();
        Object.values(this.group_wise_selected).forEach((groupArr) => {
          this.cleanIncourseErrors(groupArr);
        });
      },
    },
    selectedImprovement: {
      deep: true,
      handler() {
        this.checkSubmitButton();
        this.cleanIncourseErrors(this.selectedImprovement);
      },
    },
    compulsory_subject: {
      deep: true,
      handler() {
        this.checkSubmitButton();
        this.cleanIncourseErrors(this.compulsory_subject);
      },
    },
    errors: {
      deep: true,
      handler() {
        this.checkSubmitButton();
      },
    },
  },

  created() {
    this.current_privilege = JSON.parse(
      localStorage.getItem("current-privilege"),
    );
    this.examActivityStatus();
    this.resetArray();
  },

  methods: {
    examActivityStatus() {
      this.$store
        .dispatch("getExamActivityStatus", {
          exam_code: this.current_privilege.exam_master.exam_code,
          exam_year: this.current_privilege.exam_master.exam_year,
        })
        .then((data) => {
          console.log(data);
        });
    },
    showIncourse(paper) {
      return (
        this.ffCriteria == 1 && Number(paper.core_paper.incourse_marks) > 0
      );
    },
    showAttendance(paper) {
      return (
        this.ffCriteria == 1 && Number(paper.core_paper.att_incourse_marks) > 0
      );
    },
    searchData() {
      let subject_code = null;
      if (this.current_privilege.degree.degree_code == 1) {
        subject_code = this.current_privilege.degree_group.degree_group_code;
      } else {
        subject_code = this.current_privilege.subject_code;
      }
      const payload = {
        exam_code: this.current_privilege.exam_master.exam_code,
        exam_year: this.current_privilege.exam_master.exam_year,
        subject_code: subject_code,
        reg_no: this.searchParam.reg_no,
      };
      this.$store.dispatch("searchIncourseData", payload);
    },

    /* ========== ELECTIVE LOGIC ========== */
    showGroupBySet(group) {
      if (!group.length) return false;
      const set =
        group[0].core_paper.paper_group &&
        group[0].core_paper.paper_group.paper_group_set
          ? group[0].core_paper.paper_group.paper_group_set
          : null;
      return !this.paper_group_set || this.paper_group_set === set;
    },

    showPaperByLimit(groupName, paper) {
      this.ele_group = paper;
      const limit = paper.core_paper.paper_group
        ? paper.core_paper.paper_group.number_of_paper
        : 0;
      const selected = this.group_wise_selected[groupName] || [];
      return (
        selected.some((p) => p.paper_code === paper.paper_code) ||
        selected.length < limit
      );
    },

    toggleElective(groupName, paper) {
      const set = paper.core_paper.paper_group
        ? paper.core_paper.paper_group.paper_group_set
        : null;
      if (!this.paper_group_set) this.paper_group_set = set;

      if (!this.group_wise_selected[groupName])
        this.$set(this.group_wise_selected, groupName, []);
      const limit = paper.core_paper.paper_group
        ? paper.core_paper.paper_group.number_of_paper
        : 0;
      const arr = this.group_wise_selected[groupName];
      const index = arr.findIndex((p) => p.paper_code === paper.paper_code);

      if (index > -1) {
        arr.splice(index, 1);
        this.removePairPaper(paper);
        if (this.selectedElectiveCount() === 0) this.paper_group_set = null;
      } else {
        if (arr.length < limit) {
          arr.push(paper);
          this.handlePairPaper(groupName, paper);
        }
      }
    },

    isElectiveSelected(groupName, paper) {
      const arr = this.group_wise_selected[groupName];
      return arr && arr.some((p) => p.paper_code === paper.paper_code);
    },

    selectedElectiveCount() {
      return Object.values(this.group_wise_selected).reduce(
        (sum, arr) => sum + arr.length,
        0,
      );
    },

    handlePairPaper(groupName, paper) {
      const pairCode = paper.core_paper.pair_paper_code;
      if (!pairCode) return;
      const group = this.elective_subject[groupName];
      const pairPaper = group.find((p) => p.paper_code === pairCode);
      if (!pairPaper) return;
      const arr = this.group_wise_selected[groupName];
      if (!arr.some((p) => p.paper_code === pairCode)) arr.push(pairPaper);
    },

    removePairPaper(paper) {
      const pairCode = paper.core_paper.pair_paper_code;
      if (!pairCode) return;
      Object.keys(this.group_wise_selected).forEach((group) => {
        const arr = this.group_wise_selected[group];
        const index = arr.findIndex((p) => p.paper_code === pairCode);
        if (index > -1) arr.splice(index, 1);
      });
    },

    /* ========== IMPROVEMENT LOGIC ========== */

    isImprovementSelected(paper) {
      return this.selectedImprovement.some(
        (p) => p.paper_code === paper.paper_code,
      );
    },
    toggleImprovement(paper) {
      const index = this.selectedImprovement.findIndex(
        (p) => p.paper_code === paper.paper_code,
      );
      if (index > -1) {
        this.selectedImprovement.splice(index, 1);
      } else if (this.selectedImprovement.length < this.allowedImprovement) {
        this.selectedImprovement.push(paper);
      }
    },
    // showIncourse(paper) {
    //   return Number(paper.core_paper.incourse_marks) > 0;
    // },
    // showAttendance(paper) {
    //   return Number(paper.core_paper.att_incourse_marks) > 0;
    // },
    //  checkSubmitButton() {
    //   const compulsoryCount = this.compulsory_subject.length;
    //   const electiveCount = this.ele_sub.length;
    //   const improvementCount = this.selectedImprovement.length;

    //   const requiredImprovement = Number(this.allowedImprovement || 0);
    //   const hasElective = Object.keys(this.elective_subject).length > 0;

    //   let requiredElective = 0;

    //   if (hasElective) {
    //     // Sum required papers across ALL groups that have selections
    //     Object.entries(this.elective_subject).forEach(([groupName, group]) => {
    //       if (!group.length) return;

    //       const groupSet = group[0].core_paper.paper_group
    //         ? group[0].core_paper.paper_group.paper_group_set
    //         : null;
    //       const limit = Number(
    //         group[0].core_paper.paper_group
    //           ? group[0].core_paper.paper_group.number_of_paper
    //           : 0,
    //       );

    //       // Only count groups that belong to the active paper_group_set
    //       if (!this.paper_group_set || this.paper_group_set === groupSet) {
    //         requiredElective += limit;
    //       }
    //     });
    //   }

    //   const electiveOk =
    //     !hasElective ||
    //     (requiredElective > 0 && electiveCount === requiredElective);

    //   const improvementOk =
    //     requiredImprovement === 0 || improvementCount === requiredImprovement;

    //   const noErrors = Object.keys(this.errors).length === 0;

    //   this.show_button =
    //     compulsoryCount > 0 && electiveOk && improvementOk && noErrors;
    // },
     checkSubmitButton() {
      const compulsoryCount = this.compulsory_subject.length;
      const electiveCount = this.ele_sub.length;
      const improvementCount = this.selectedImprovement.length;

      const requiredImprovement = Number(this.allowedImprovement || 0);
      const hasElective = Object.keys(this.elective_subject).length > 0;

      let requiredElective = 0;

      if (hasElective) {
        // Sum required papers across ALL groups that have selections
        Object.entries(this.elective_subject).forEach(([groupName, group]) => {
          if (!group.length) return;

          const groupSet = group[0].core_paper.paper_group
            ? group[0].core_paper.paper_group.paper_group_set
            : null;
          const limit = Number(
            group[0].core_paper.paper_group
              ? group[0].core_paper.paper_group.number_of_paper
              : 0,
          );

          // Only count groups that belong to the active paper_group_set
          if (!this.paper_group_set || this.paper_group_set === groupSet) {
            requiredElective += limit;
          }
        });
      }

      const electiveOk =
        !hasElective ||
        (requiredElective > 0 && electiveCount === requiredElective);

      const improvementOk =
        requiredImprovement === 0 || improvementCount === requiredImprovement;

      const noErrors = Object.keys(this.errors).length === 0;

      this.show_button =
        compulsoryCount > 0 && electiveOk && improvementOk && noErrors;
    },

    resetAllData() {
      this.group_wise_selected = {};
      this.selectedImprovement = [];
      this.paper_group_set = null;
      this.errors = {};
      this.submitted = false;
      this.show_button = false;
    },

    submitInvMarks() {
      const papers = [];
      /* ========= COMPULSORY ========= */
      this.compulsory_subject.forEach((p) => {
        papers.push({
          paper_code: p.core_paper.paper_code,
          att_incourse_marks: p.att_incourse_marks || null,
          incourse_paper_marks: p.incourse_paper_marks || null,
          ffd_id: p.id || null,
        });
      });
      /* ========= ELECTIVE ========= */
      Object.values(this.group_wise_selected).forEach((groupArr) => {
        groupArr.forEach((p) => {
          papers.push({
            paper_code: p.core_paper.paper_code,
            att_incourse_marks: p.att_incourse_marks || null,
            incourse_paper_marks: p.incourse_paper_marks || null,
            ffd_id: p.id || null,
          });
        });
      });
      /* ========= IMPROVEMENT ========= */
      this.selectedImprovement.forEach((p) => {
        papers.push({
          paper_code: p.core_paper.paper_code,
          att_incourse_marks: p.att_incourse_marks || null,
          incourse_paper_marks: p.incourse_paper_marks || null,
          ffd_id: p.id || null,
        });
      });
      // ===== Validation Section =====
      let hasError = false;
      const missingMarks = [];

      // --- Compulsory ---
      this.compulsory_subject.forEach((p) => {
        // Attendance validation
        if (p.att_incourse_status === true) {
          const marks = p.att_incourse_marks;
          const max = p.core_paper.att_incourse_marks;
          const min = p.core_paper.min_att_incourse_marks;

          if (marks === null || marks === "" || marks === undefined) {
            missingMarks.push(
              p.core_paper.paper_code + " (Attendance Missing)",
            );
            hasError = true;
          } else if (marks > max || marks < min) {
            missingMarks.push(
              `${p.core_paper.paper_code} (Attendance must be between ${min} - ${max})`,
            );
            hasError = true;
          }
        }
        // Incourse validation
        if (p.incourse_status === true) {
          const marks = p.incourse_paper_marks;
          const max = p.core_paper.incourse_marks;
          const min = p.core_paper.minimum_incourse_marks;

          if (marks === null || marks === "" || marks === undefined) {
            missingMarks.push(p.core_paper.paper_code + " (Incourse Missing)");
            hasError = true;
          } else if (marks > max || marks < min) {
            missingMarks.push(
              `${p.core_paper.paper_code} (Incource Marks must be between ${min} - ${max})`,
            );
            hasError = true;
          }
        }
      });
      // --- Elective ---
      Object.values(this.group_wise_selected).forEach((groupArr) => {
        groupArr.forEach((p) => {
          if (p.att_incourse_status === true) {
            const marks = p.att_incourse_marks;
            const max = p.core_paper.att_incourse_marks;
            const min = p.core_paper.min_att_incourse_marks;

            if (marks === null || marks === "" || marks === undefined) {
              missingMarks.push(
                p.core_paper.paper_code + " (Attendance Missing)",
              );
              hasError = true;
            } else if (marks > max || marks < min) {
              missingMarks.push(
                `${p.core_paper.paper_code} (Attendance must be between ${min} - ${max})`,
              );
              hasError = true;
            }
          }
          if (p.incourse_status === true) {
            const marks = p.incourse_paper_marks;
            const max = p.core_paper.incourse_marks;
            const min = p.core_paper.minimum_incourse_marks;

            if (marks === null || marks === "" || marks === undefined) {
              missingMarks.push(
                p.core_paper.paper_code + " (Incourse Missing)",
              );
              hasError = true;
            } else if (marks > max || marks < min) {
              missingMarks.push(
                `${p.core_paper.paper_code} (Incourse must be between ${min} - ${max})`,
              );
              hasError = true;
            }
          }
        });
      });
      // --- Improvement ---
      this.selectedImprovement.forEach((p) => {
        if (p.att_incourse_status === true) {
          const marks = p.att_incourse_marks;
          const max = p.core_paper.att_incourse_marks;
          const min = p.core_paper.min_att_incourse_marks;
          if (marks === null || marks === "" || marks === undefined) {
            missingMarks.push(
              p.core_paper.paper_code + " (Attendance Missing)",
            );
            hasError = true;
          } else if (marks > max || marks < min) {
            missingMarks.push(
              `${p.core_paper.paper_code} (Attendance must be between ${min} - ${max})`,
            );
            hasError = true;
          }
        }
        if (p.incourse_status === true) {
          const marks = p.incourse_paper_marks;
          const max = p.core_paper.incourse_marks;
          const min = p.core_paper.minimum_incourse_marks;
          if (marks === null || marks === "" || marks === undefined) {
            missingMarks.push(p.core_paper.paper_code + " (Incourse Missing)");
            hasError = true;
          } else if (marks > max || marks < min) {
            missingMarks.push(
              `${p.core_paper.paper_code} (Incourse must be between ${min} - ${max})`,
            );
            hasError = true;
          }
        }
      });

      const errors = {};

      const validatePaper = (p) => {
        const incourseKey = p.core_paper.paper_code + "_incourse";
        const attKey = p.core_paper.paper_code + "_attendance";
        // reset
        errors[incourseKey] = [];
        errors[attKey] = [];
        // ========= Incourse =========
        if (p.incourse_status) {
          if (
            p.incourse_paper_marks === null ||
            p.incourse_paper_marks === "" ||
            p.incourse_paper_marks === undefined
          ) {
            errors[incourseKey].push(
              `Please enter value (${p.core_paper.minimum_incourse_marks} - ${p.core_paper.incourse_marks})`,
            );
          } else {
            const marks = Number(p.incourse_paper_marks);

            if (marks < p.core_paper.minimum_incourse_marks) {
              errors[incourseKey].push(
                "Minimum " + p.core_paper.minimum_incourse_marks,
              );
            }

            if (marks > p.core_paper.incourse_marks) {
              errors[incourseKey].push(
                "Maximum " + p.core_paper.incourse_marks,
              );
            }
          }
        }
        // ========= Attendance =========
        if (p.att_incourse_status) {
          if (
            p.att_incourse_marks === null ||
            p.att_incourse_marks === "" ||
            p.att_incourse_marks === undefined
          ) {
            errors[attKey].push(
              `Please enter value (${p.core_paper.min_att_incourse_marks} - ${p.core_paper.att_incourse_marks})`,
            );
          } else {
            const marks = Number(p.att_incourse_marks);

            if (marks < p.core_paper.min_att_incourse_marks) {
              errors[attKey].push(
                "Minimum " + p.core_paper.min_att_incourse_marks,
              );
            }

            if (marks > p.core_paper.att_incourse_marks) {
              errors[attKey].push("Maximum " + p.core_paper.att_incourse_marks);
            }
          }
        }
        if (errors[incourseKey].length === 0) delete errors[incourseKey];
        if (errors[attKey].length === 0) delete errors[attKey];
      };
      this.compulsory_subject.forEach(validatePaper);
      Object.values(this.group_wise_selected).forEach((groupArr) => {
        groupArr.forEach(validatePaper);
      });
      this.selectedImprovement.forEach(validatePaper);
      this.errors = errors;
      this.checkSubmitButton();
      this.submitted = true;
      if (Object.keys(this.errors).length > 0) {
        return;
      }
      let subject_code = null;
      if (this.current_privilege.degree.degree_code == 1) {
        subject_code = this.current_privilege.degree_group.degree_group_code;
      } else {
        subject_code = this.current_privilege.subject_code;
      }
      const payload = {
        exam_code: this.current_privilege.exam_master.exam_code,
        exam_year: this.current_privilege.exam_master.exam_year,
        reg_no: this.searchParam.reg_no,
        form_fill_up_id: this.apiData.form_fill_up.id,
        degree_code: this.current_privilege.degree_code,
        degree_group_code: this.current_privilege.degree_group_code,
        subject_code: subject_code,
        papers: papers,
      };

      console.log("Final Payload:", payload);
      this.$store.dispatch("submitIncourseMarks", payload).then(() => {
        this.searchParam.reg_no = "";
        this.resetAllData();
      });
    },

    resetArray() {
      console.log("Resetting array data...");
      this.$store.dispatch("resetIncourseData");
    },
    cleanIncourseErrors(subjectList) {
      subjectList.forEach((p) => {
        const incourseKey = p.core_paper.paper_code + "_incourse";
        const attKey = p.core_paper.paper_code + "_attendance";
        /* ========= Incourse ========= */
        if (p.incourse_status) {
          const marks = p.incourse_paper_marks;
          if (marks !== null && marks !== "" && marks !== undefined) {
            const num = Number(marks);
            if (
              num >= p.core_paper.minimum_incourse_marks &&
              num <= p.core_paper.incourse_marks
            ) {
              delete this.errors[incourseKey];
            }
          }
        }
        /* ========= Attendance ========= */
        if (p.att_incourse_status) {
          const marks = p.att_incourse_marks;
          if (marks !== null && marks !== "" && marks !== undefined) {
            const num = Number(marks);
            if (
              num >= p.core_paper.min_att_incourse_marks &&
              num <= p.core_paper.att_incourse_marks
            ) {
              delete this.errors[attKey];
            }
          }
        }
      });
      this.checkSubmitButton();
    },
  },
};
</script>

<style>
.data-bar {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
  padding: 12px 20px;

  border: 1px solid #e2e8f0;
  border-radius: 8px;

  background: white;
}

.item {
  display: flex;
  gap: 6px;
}

.label {
  font-weight: 700;
  color: #64748b;
}

.value {
  font-weight: 500;
  color: #1e293b;
}

.paper-group {
  margin-bottom: 20px;
}

.group-label {
  padding: 6px 10px;
  font-weight: 600;
  background: #f1f5f9;
  border-radius: 4px;
  margin-bottom: 6px;
}
</style>
